// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GG7yl","header":"styles_header__KTCOk","row":"styles_row__ejX83","center":"styles_center__1bGrH"};